/* Kräutermax Theme — globales JS */
(function () {
  'use strict';

  /* ---------- Mobile Off-Canvas Menü ---------- */
  var drawer = document.querySelector('[data-menu-drawer]');
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) { openDrawer(); }
    else if (e.target.closest('[data-menu-close]')) { closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------- Live-Suche (Predictive Search) ---------- */
  var psForm = document.querySelector('[data-predictive-search]');
  if (psForm) {
    var psInput = psForm.querySelector('[data-predictive-input]');
    var psResults = psForm.querySelector('[data-predictive-results]');
    var psTimer;
    var RECENT_KEY = 'km_recent_searches';
    var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var psClose = function () { psResults.hidden = true; psResults.innerHTML = ''; };

    /* Icons */
    var ICON_HISTORY = '<svg class="km-predict__ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 7v5l3 2"/><path d="M3.5 12a8.5 8.5 0 1 0 2.4-5.9M4 4v3h3"/></svg>';
    var ICON_SUGGEST = '<svg class="km-predict__ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6"/><path d="M15 15l4.5 4.5"/></svg>';
    var ICON_PAGE = '<svg class="km-predict__ico km-predict__ico--doc" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M6 3h8l4 4v14H6z"/><path d="M14 3v4h4"/><path d="M9 12h6M9 16h6"/></svg>';
    var ICON_ARTICLE = '<svg class="km-predict__ico km-predict__ico--doc" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 5h13v14H4z"/><path d="M17 8h3v9a2 2 0 0 1-2 2h-1"/><path d="M7 9h7M7 12h7M7 15h4"/></svg>';

    /* Zuletzt gesucht (localStorage) */
    var recentGet = function () { try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (e) { return []; } };
    var recentAdd = function (term) {
      term = (term || '').trim();
      if (term.length < 2) return;
      var list = recentGet().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
      list.unshift(term);
      try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 6))); } catch (e) {}
    };
    var recentClear = function () { try { localStorage.removeItem(RECENT_KEY); } catch (e) {} };

    /* Textvervollständigung: passende Begriffe aus Treffer-Titeln ableiten */
    var deriveTerms = function (products, q) {
      var ql = q.toLowerCase(), seen = {}, terms = [];
      seen[ql] = 1;
      products.forEach(function (p) {
        var src = (p.title || '') + ' ' + (p.type || '');
        src.split(/[\s,.\/\-–—()|]+/).forEach(function (w) {
          var wl = w.toLowerCase();
          if (w.length > q.length && wl.indexOf(ql) === 0 && !seen[wl]) { seen[wl] = 1; terms.push(w); }
        });
      });
      return terms.slice(0, 4);
    };

    var renderRecent = function () {
      var list = recentGet();
      if (!list.length) { psClose(); return; }
      var html = '<div class="km-predict__head km-predict__head--row">Zuletzt gesucht<button type="button" class="km-predict__clear" data-recent-clear>Löschen</button></div>';
      list.forEach(function (t) {
        html += '<button type="button" class="km-predict__term" data-term="' + esc(t) + '">' + ICON_HISTORY + '<span>' + esc(t) + '</span></button>';
      });
      psResults.innerHTML = html;
      psResults.hidden = false;
    };

    var psRender = function (data, q) {
      var r = data.resources && data.resources.results;
      var products = ((r && r.products) || []).slice(0, 6);
      var pages = ((r && r.pages) || []).slice(0, 3);
      var articles = ((r && r.articles) || []).slice(0, 3);
      var html = '';

      var terms = deriveTerms(products, q);
      if (terms.length) {
        html += '<div class="km-predict__head">Vorschläge</div>';
        terms.forEach(function (t) {
          html += '<button type="button" class="km-predict__term" data-term="' + esc(t) + '">' + ICON_SUGGEST + '<span>' + esc(t) + '</span></button>';
        });
      }

      if (products.length) {
        html += '<div class="km-predict__head">Produkte</div>';
        products.forEach(function (p) {
          var img = p.image ? '<img class="km-predict__thumb" src="' + esc(p.image) + '" alt="" width="44" height="44" loading="lazy">' : '<span class="km-predict__thumb"></span>';
          var price = p.price ? '<div class="km-predict__price">' + esc(p.price) + '</div>' : '';
          html += '<a class="km-predict__item" href="' + esc(p.url) + '">' + img + '<div class="km-predict__info"><div class="km-predict__title">' + esc(p.title) + '</div>' + price + '</div></a>';
        });
      }

      if (pages.length) {
        html += '<div class="km-predict__head">Seiten</div>';
        pages.forEach(function (p) {
          html += '<a class="km-predict__item km-predict__item--doc" href="' + esc(p.url) + '">' + ICON_PAGE + '<div class="km-predict__info"><div class="km-predict__title">' + esc(p.title) + '</div></div></a>';
        });
      }

      if (articles.length) {
        html += '<div class="km-predict__head">Magazin</div>';
        articles.forEach(function (a) {
          var img = a.image ? '<img class="km-predict__thumb" src="' + esc(a.image) + '" alt="" width="44" height="44" loading="lazy">' : ICON_ARTICLE;
          html += '<a class="km-predict__item km-predict__item--doc" href="' + esc(a.url) + '">' + img + '<div class="km-predict__info"><div class="km-predict__title">' + esc(a.title) + '</div></div></a>';
        });
      }

      if (!products.length && !pages.length && !articles.length) {
        html = '<div class="km-predict__empty">Keine Treffer für „' + esc(q) + '"</div>';
      }

      html += '<a class="km-predict__more" href="/search?q=' + encodeURIComponent(q) + '">Alle Ergebnisse für „' + esc(q) + '" →</a>';
      psResults.innerHTML = html;
      psResults.hidden = false;
    };

    var doSearch = function (q) {
      psResults.innerHTML = '<div class="km-predict__loading">Suche …</div>';
      psResults.hidden = false;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product,page,article'
        + '&resources[limit]=6'
        + '&resources[options][unavailable_products]=last'
        + '&resources[options][fields]=title,vendor,product_type,variants.title,variants.sku';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (data) { if (psInput.value.trim() === q) psRender(data, q); })
        .catch(function () { psClose(); });
    };

    psInput.addEventListener('input', function () {
      var q = psInput.value.trim();
      clearTimeout(psTimer);
      if (q.length < 2) { renderRecent(); return; }
      psTimer = setTimeout(function () { doSearch(q); }, 220);
    });

    psInput.addEventListener('focus', function () {
      var q = psInput.value.trim();
      if (q.length < 2) { renderRecent(); }
      else if (psResults.innerHTML) { psResults.hidden = false; }
    });

    /* Klick auf Vorschlag / zuletzt-gesucht-Begriff → Suche verfeinern */
    psResults.addEventListener('click', function (e) {
      var clr = e.target.closest('[data-recent-clear]');
      if (clr) { e.preventDefault(); e.stopPropagation(); recentClear(); renderRecent(); psInput.focus(); return; }
      var term = e.target.closest('[data-term]');
      if (term) { e.preventDefault(); psInput.value = term.getAttribute('data-term'); psInput.focus(); doSearch(psInput.value.trim()); return; }
      var link = e.target.closest('a[href]');
      if (link) { recentAdd(psInput.value); }
    });

    /* Bei Absenden (Enter → Ergebnisseite) Begriff merken */
    psForm.addEventListener('submit', function () { recentAdd(psInput.value); });

    document.addEventListener('click', function (e) { if (!psForm.contains(e.target)) psClose(); });

    /* Tastatur: Pfeile navigieren, Enter folgt aktivem Eintrag, Escape schließt */
    psInput.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { psClose(); psInput.blur(); return; }
      if (psResults.hidden) return;
      var items = Array.prototype.slice.call(psResults.querySelectorAll('.km-predict__item, .km-predict__term, .km-predict__more'));
      if (!items.length) return;
      var idx = items.indexOf(psResults.querySelector('.is-active'));
      if (e.key === 'ArrowDown') {
        e.preventDefault(); idx = (idx + 1) % items.length;
      } else if (e.key === 'ArrowUp') {
        e.preventDefault(); idx = (idx <= 0 ? items.length : idx) - 1;
      } else if (e.key === 'Enter') {
        if (idx > -1) { e.preventDefault(); recentAdd(psInput.value); items[idx].click(); }
        return;
      } else { return; }
      items.forEach(function (it) { it.classList.remove('is-active'); });
      if (items[idx]) { items[idx].classList.add('is-active'); items[idx].scrollIntoView({ block: 'nearest' }); }
    });
  }

  /* ---------- „Frag Max“ → Shopify-Chat öffnen ---------- */
  var chatBtn = document.querySelector('[data-chat-open]');
  if (chatBtn) {
    var openShopifyChat = function () {
      var el = document.querySelector('shopify-chat');
      if (el && typeof el.show === 'function') { el.show(); return true; }
      return false;
    };
    chatBtn.addEventListener('click', function (e) {
      // Chat sofort verfügbar?
      if (openShopifyChat()) { e.preventDefault(); return; }
      // Sonst kurz warten (App-Embed lädt verzögert); ansonsten dem Link folgen
      e.preventDefault();
      var href = chatBtn.getAttribute('href');
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (openShopifyChat()) { clearInterval(iv); }
        else if (tries > 16) { clearInterval(iv); if (href) window.location.href = href; }
      }, 250);
    });
  }

  /* ---------- Footer „Widerrufsbutton" → App-Formular öffnen ---------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href$="#widerruf"], [data-widerruf-open]');
    if (!link) return;
    e.preventDefault();
    // Offizielle API der App bevorzugen: ihr eigener Auslöse-Button ist per
    // Theme-CSS ausgeblendet, ein .click() darauf oeffnet das Modal nicht.
    if (window.withdrawalModal && typeof window.withdrawalModal.open === 'function') {
      window.withdrawalModal.open();
      return;
    }
    var trigger = document.getElementById('wb-trigger-btn') || document.querySelector('.wb-btn-trigger');
    if (trigger) { trigger.click(); return; }
    // Letzter Ausweg, damit der Link nie ins Leere fuehrt:
    window.location.href = '/policies/refund-policy';
  });

  /* ---------- Nach-oben-Button ---------- */
  var toTop = document.querySelector('[data-totop]');
  if (toTop) {
    var onScroll = function () { toTop.classList.toggle('is-visible', window.scrollY > 600); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    toTop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---------- Warenkorb-Zähler aktualisieren ---------- */
  window.kmUpdateCartCount = function () {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
      })
      .catch(function () {});
  };

  /* ---------- Collection: aufklappbare Beschreibung ---------- */
  var collDesc = document.querySelector('[data-colldesc]');
  var collDescBtn = document.querySelector('[data-colldesc-toggle]');
  if (collDesc && collDescBtn) {
    if (collDesc.scrollHeight - collDesc.clientHeight > 4) {
      collDescBtn.hidden = false;
      collDescBtn.addEventListener('click', function () {
        var open = collDesc.classList.toggle('is-open');
        collDescBtn.textContent = open ? 'Weniger anzeigen' : 'Mehr anzeigen';
      });
    }
  }

  /* ---------- Collection: Filter & Sortierung ---------- */
  var facetForm = document.querySelector('.km-facets');
  if (facetForm) {
    facetForm.addEventListener('change', function () { facetForm.submit(); });
  }
  var productGrid = document.querySelector('[data-product-grid]');
  document.querySelectorAll('[data-view]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!productGrid) return;
      var list = btn.getAttribute('data-view') === 'list';
      productGrid.classList.toggle('km-grid--list', list);
      document.querySelectorAll('[data-view]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
    });
  });
  var sortSelect = document.querySelector('[data-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Warenkorb: Mengen ändern ---------- */
  var cartForm = document.getElementById('cart');
  if (cartForm) {
    cartForm.addEventListener('click', function (e) {
      var dec = e.target.closest('[data-cart-dec]');
      var inc = e.target.closest('[data-cart-inc]');
      if (!dec && !inc) return;
      var row = e.target.closest('[data-cart-row]');
      var input = row && row.querySelector('[data-cart-qty]');
      if (!input) return;
      var val = parseInt(input.value || '1', 10);
      input.value = inc ? val + 1 : Math.max(0, val - 1);
      cartForm.submit();
    });
    cartForm.addEventListener('change', function (e) {
      if (e.target.closest('[data-cart-qty]')) cartForm.submit();
    });
  }

  /* ---------- Länder-/Währungsauswahl (Footer) ---------- */
  var locSel = document.querySelector('[data-loc-select]');
  if (locSel && locSel.form) {
    locSel.addEventListener('change', function () { locSel.form.submit(); });
  }

  /* ---------- Mini-Warenkorb (Schublade) ---------- */
  function kmMoney(cents) {
    return '€ ' + (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  // Staffelpreis einer Warenkorb-Zeile SELBST berechnen (deterministisch, identisch zu BSS):
  // ab 3 Stk. −10 %, ab 6 Stk. −15 %. Ausgenommen: Aktionen, Mehrfachvarianten, Sparabo, bereits rabattierte Zeilen.
  // Wir verlassen uns NICHT mehr auf BSS zum Befüllen der Drawer-Anzeige (das war unzuverlässig / leerte das Element).
  function kmDrawerLine(it) {
    var lineOrig = (it.original_line_price != null ? it.original_line_price : it.price * it.quantity);
    var pct = 0;
    var eligible = it.product_has_only_default_variant
      && it.product_type !== 'Aktionen'
      && !it.selling_plan_allocation
      && it.price === it.original_price;
    if (eligible) {
      if (it.quantity >= 6) pct = 15;
      else if (it.quantity >= 3) pct = 10;
    }
    // BSS rundet den Rabattbetrag pro Stück (nicht den Endpreis): unit = price − round(price·pct/100)
    var discUnit = Math.round(it.price * pct / 100);
    var lineDisc = pct > 0 ? ((it.price - discUnit) * it.quantity) : lineOrig;
    return { pct: pct, lineOrig: lineOrig, lineDisc: lineDisc };
  }
  function kmRenderCart(cart) {
    var body = document.querySelector('[data-cart-body]');
    var foot = document.querySelector('[data-cart-foot]');
    if (!body) return;
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="km-cd__empty">Ihr Warenkorb ist leer.</div>';
      if (foot) foot.hidden = true;
      return;
    }
    var subtotal = 0;
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<span class="km-cd__thumb"><img src="' + it.image + '" alt="" width="64" height="64"></span>' : '<span class="km-cd__thumb"></span>';
      var variant = (it.variant_title && it.variant_title.indexOf('Default') === -1) ? '<div class="km-cd__variant">' + it.variant_title + '</div>' : '';
      var d = kmDrawerLine(it);
      subtotal += d.lineDisc;
      var priceHtml;
      if (d.pct > 0) {
        priceHtml = '<span class="km-cd__price-old">' + kmMoney(d.lineOrig) + '</span>' +
                    '<span class="km-cd__price">' + kmMoney(d.lineDisc) + '</span>' +
                    '<span class="km-cd__price-badge">−' + d.pct + ' %</span>';
      } else {
        priceHtml = '<span class="km-cd__price">' + kmMoney(d.lineOrig) + '</span>';
      }
      // Unsichtbarer BSS-Hook: BSS verarbeitet die Zeile (isModifiedPrice) → „Zur Kasse" legt Draft-Order mit Staffelpreis an.
      // Die sichtbare Anzeige oben berechnen wir selbst; BSS berührt sie nicht mehr.
      var bssHook = '<span class="km-cd__bsshook" bss-b2b-cart-item-key="' + it.key + '" bss-b2b-final-line-price>' + kmMoney(d.lineOrig) + '</span>';
      return '<div class="km-cd__item" data-key="' + it.key + '">' + img +
        '<div><a class="km-cd__name" href="' + it.url + '">' + it.product_title + '</a>' + variant +
        '<div class="km-cd__qty"><button type="button" data-cd-dec aria-label="Weniger">−</button><span>' + it.quantity + '</span><button type="button" data-cd-inc aria-label="Mehr">+</button></div></div>' +
        '<div class="km-cd__right"><div class="km-cd__pricebox">' + priceHtml + bssHook + '</div><button type="button" class="km-cd__remove" data-cd-remove>Entfernen</button></div>' +
        '</div>';
    }).join('');
    if (foot) {
      foot.hidden = false;
      var sub = foot.querySelector('[data-cart-subtotal]');
      if (sub) sub.textContent = kmMoney(subtotal);
    }
  }
  function kmFetchAndRender() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      kmRenderCart(cart);
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.classList.toggle('is-empty', cart.item_count === 0); });
      return cart;
    });
  }
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  window.kmOpenCartDrawer = function () {
    if (!cartDrawer) return;
    kmFetchAndRender();
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };
  function kmCloseCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) { kmCloseCartDrawer(); return; }
    // Warenkorb-Icon im Header öffnet die Schublade (Fallback: Link zur Seite)
    var cartLink = e.target.closest('.km-icon-btn--cart');
    if (cartLink && cartDrawer) { e.preventDefault(); window.kmOpenCartDrawer(); return; }
    var dec = e.target.closest('[data-cd-dec]'), inc = e.target.closest('[data-cd-inc]'), rem = e.target.closest('[data-cd-remove]');
    if (!dec && !inc && !rem) return;
    var row = e.target.closest('[data-key]');
    if (!row) return;
    var key = row.getAttribute('data-key');
    var span = row.querySelector('.km-cd__qty span');
    var cur = span ? parseInt(span.textContent, 10) : 1;
    var q = rem ? 0 : (inc ? cur + 1 : Math.max(0, cur - 1));
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
      .then(function (r) { return r.json(); }).then(function (cart) { kmRenderCart(cart); document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.classList.toggle('is-empty', cart.item_count === 0); }); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') kmCloseCartDrawer(); });

  /* ---------- AJAX „In den Warenkorb" ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action$="/cart/add"]');
    if (!form || form.hasAttribute('data-no-ajax')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = '…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.textContent = '✓ Hinzugefügt'; setTimeout(function () { btn.textContent = btn.dataset.label; btn.disabled = false; }, 1600); }
        if (cartDrawer) { window.kmOpenCartDrawer(); } else { window.kmUpdateCartCount(); }
      })
      .catch(function () {
        if (btn) { btn.textContent = btn.dataset.label; btn.disabled = false; }
      });
  });
})();

/* iubenda Cookie-Einstellungen-Button („Schloss") umpositionieren: unten LINKS, oberhalb des Chat-Buttons.
   Die App positioniert per eigenem !important-Stylesheet-Regel (html body button.iubenda-tp-btn…),
   die die CSS-Regeln im <head> überspezifiziert. Nur ein Inline-Style (!important) gewinnt zuverlässig,
   sonst bleibt das Schloss unten rechts und überdeckt den Go-to-Top-Button. */
(function () {
  function place(b) {
    // Rechts, aber oberhalb des Go-to-Top-Buttons (der sitzt bei right:20px/bottom:20px, 46px hoch → bis 66px).
    b.style.setProperty('right', '20px', 'important');
    b.style.setProperty('left', 'auto', 'important');
    b.style.setProperty('bottom', '78px', 'important');
    b.style.setProperty('top', 'auto', 'important');
    if (window.matchMedia('(max-width: 749px)').matches) {
      b.style.setProperty('right', '14px', 'important');
      b.style.setProperty('bottom', '74px', 'important');
    }
  }
  function kmMoveIubenda() {
    var b = document.querySelector('.iubenda-tp-btn.iubenda-cs-preferences-link, .iubenda-tp-btn');
    if (b) { place(b); return true; }
    return false;
  }
  if (!kmMoveIubenda()) {
    var tries = 0;
    var iv = setInterval(function () {
      if (kmMoveIubenda() || ++tries > 30) clearInterval(iv); // bis ~15 s auf das App-Widget warten
    }, 500);
  }
})();